import { useProductPageStore } from '../../contexts/ProductPageStore'

import React, { useContext, useEffect } from 'react'
import { useInView } from 'react-intersection-observer'

import { useRecommendationStore } from 'Clutch/Stores/RecommendationStore/RecommendationStore'
import ErrorBoundary from 'Clutch/UtilityComponents/ErrorBoundary'

import RecommendationSection from 'Clutch/Organisms/RecommendationSection/RecommendationSection'

const AsideRecommendations = ({ testData }) => {
  const section = 'PDP_Aside'
  const keywords = useRecommendationStore((x) => x.keywords)
  const scrollToTopAndStartNavigation = useProductPageStore((x) => x.scrollToTopAndStartNavigation)
  const originSku = useProductPageStore((x) => x.skuBaseNumber)

  return (
    <ErrorBoundary>
      <RecommendationSection
        section={section}
        displayType={'Vertical'}
        skeletonDisplayType={'Vertical'}
        numberOfSkeletons={3}
        testData={testData}
        spacingSize={'None'}
        keywords={keywords}
        isCard
        useSubtitle
        useDivider
        useItemCount
        noMargin
        nextLink
        prefetch={false}
        onClick={scrollToTopAndStartNavigation}
        showAddToCart={true}
        originSku={originSku}
      />
    </ErrorBoundary>
  )
}

export default AsideRecommendations
